var fails = require('../internals/fails');

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/internals/descriptors.js